import { apiClient } from "@/services/api/axiosClient";
import type { PropertySubmissionData } from "./propertiesTypes";
import type { ApiResponse } from "@/services/api/api.types";

/**
 * Properties API - API calls for properties feature
 */
export const submitPropertyProtestApi = async (data: PropertySubmissionData): Promise<void> => {
  const response = await apiClient.post<ApiResponse<void>>("/properties/protest", data);
  return response.data.data;
};
